import { css } from '@emotion/react'
import { cssVar, Spacing, ThemedColors } from '@opallabs/gem'

// Inset to where every other value's text starts, so the first face lines up
// with the label above it.
export const readOnlyAvatarList = css({
  paddingBlock: Spacing.S + 1,
  paddingInline: Spacing.S + 1,
})

export const selectOverrides = css({
  '.multi-select-value-input': {
    backgroundColor: cssVar(ThemedColors.Surface1),

    '.multi-select-value-input-placeholder': {
      display: 'none',
    },

    '&[aria-expanded="false"]': {
      borderColor: 'transparent',

      '.multi-select-toggle': {
        display: 'none',
      },

      '.multi-select-value-input-placeholder': {
        color: cssVar(ThemedColors.TextSecondary),
        display: 'inline',
      },

      '&:hover': {
        backgroundColor: cssVar(ThemedColors.Surface2),
      },
    },
  },
})
